import { Notification } from 'types';
import { CapitolaClient } from './base';

export class NotificationClient extends CapitolaClient<Notification> {
  public get resourceName(): string {
    return 'notification';
  }
}
